module.exports = __webpack_public_path__ + "assets/a93bfaaf623fba7c517ec426c4dcd1d2.svg";